'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondsFromNow;


// WEBPACK FOOTER //
// ./~/sugar-date/number/millisecondsFromNow.js